/* eslint-disable */
export const handleValidation = (inputFields) => {
  const formData = inputFields;
  const errors = {};
  // if (!formData.ipdNo) {
  //   errors.ipdNo = 'Ipd  is required';
  // }

  if (!formData.wardID) {
    errors.wardID = 'Ward is required';
  }
  if (!formData.bedID) {
    errors.bedID = 'Bed is required';
  }

  if (!formData.admissionDate) {
    errors.admissionDate = 'Admission Date is required';
  }

 
  const checlInsuranceDetailExists = inputFields.hasOwnProperty("insuranceDetail")
  if (checlInsuranceDetailExists) {
    // For nested fields, validate them similarly
    if (!formData.insuranceDetail.insuranceID) {
      errors.insuranceDetail = { ...errors.insuranceDetail, insuranceID: 'Insurance is required' };
    }

    if (!formData.insuranceDetail.packageID) {
      errors.insuranceDetail = { ...errors.insuranceDetail, packageID: 'package is required' };
    }

    if (!formData.insuranceDetail.cardID) {
      errors.insuranceDetail = { ...errors.insuranceDetail, cardID: 'Card is required' };
    }
    if (!formData.insuranceDetail.cardNumber) {
      errors.insuranceDetail = { ...errors.insuranceDetail, cardNumber: 'Card Number is required' };
    }
    if (!formData.insuranceDetail.cardIssueDate) {
      errors.insuranceDetail = { ...errors.insuranceDetail, cardIssueDate: 'Card Issue Date is required' };
    }
    if (!formData.insuranceDetail.cardExpiryDate) {
      errors.insuranceDetail = { ...errors.insuranceDetail, cardExpiryDate: 'Card ExpiryDate  is required' };
    }
    if (!formData.insuranceDetail.membershipNumber) {
      errors.insuranceDetail = { ...errors.insuranceDetail, membershipNumber: 'Membership Number is required' };
    }

    if (!formData.insuranceDetail.relationWithPatient) {
      errors.insuranceDetail = { ...errors.insuranceDetail, relationWithPatient: 'Relation With Patient is required' };
    }
    if (!formData.insuranceDetail.amount) {
      errors.insuranceDetail = { ...errors.insuranceDetail, amount: 'Amount is required' };
    }
    if (!formData.insuranceDetail.cardHolderName) {
      errors.insuranceDetail = { ...errors.insuranceDetail, cardHolderName: 'Card Holder Name is required' };
    }
  }

  // Return true if there are no errors
  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};





